<template>
  <div style="min-height: 750px;" v-if="d_userDiscountWdm">
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8"></b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
    <b-row style="margin-bottom: 20px; border-bottom: solid 1px whitesmoke;">
      <b-col sm="12" md="2" lg="2"> </b-col>
      <b-col sm="12" md="4" lg="4">
        <i class="fa fa-desktop"></i>
        {{ StoreLangTranslation.data['user_discount_record'][StoreLang] }}
      </b-col>
      <b-col sm="12" md="4" lg="4" :style="StoreDevice.isMobile ? '' : 'text-align: right;'"></b-col>
      <b-col sm="12" md="2" lg="2"></b-col>
    </b-row>
    <b-row>
      <b-col sm="12" lg="2"></b-col>
      <b-col sm="12" lg="8">


        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userDiscountWdm['0']['parameters']['0']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userDiscountData.status">
              <option v-for="(op, op_index) in d_userDiscountWdm['0']['parameters']['0'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userDiscountWdm['0']['parameters']['3']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <select class="form-control" v-model="d_userDiscountData.discount_type">
              <option v-for="(op, op_index) in d_userDiscountWdm['0']['parameters']['3'].options" :value="op.value">
                {{ op.translation[StoreLang] }}
              </option>
            </select>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userDiscountWdm['0']['parameters']['5']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
          </b-col>
        </b-row>
        <b-row style="margin: 3px;" v-for="(lang, lang_index) in StoreLangList.data">
          <b-col sm="12" lg="1">
            {{ lang.label }}
          </b-col>
          <b-col sm="12" lg="11">
            <b-form-textarea class="form-control" rows="5" v-model="d_userDiscountData.discount_name[lang.label]"></b-form-textarea>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userDiscountWdm['0']['parameters']['1']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="text" v-model="d_userDiscountData.discount_start_date"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userDiscountWdm['0']['parameters']['2']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="text" v-model="d_userDiscountData.discount_end_date"></b-form-input>
          </b-col>
        </b-row>
        <hr>
        <b-row style="margin: 3px;">
          <b-col sm="12" lg="4">
            <strong>{{ d_userDiscountWdm['0']['parameters']['6']['name']['translation'][StoreLang] }}</strong>
          </b-col>
          <b-col sm="12" lg="8">
            <b-form-input type="text" v-model="d_userDiscountData.discount_percent"></b-form-input>
          </b-col>
        </b-row>
        <hr>

        <b-row style="margin: 3px;">
          <b-col sm="12" lg="6">
          </b-col>
          <b-col sm="12" lg="6">
            <b-button variant="secondary" @click="f_userDiscountRecord()">
              {{ StoreLangTranslation.data['save'][StoreLang] }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
      <b-col sm="12" lg="2"></b-col>
    </b-row>
  </div>
</template>

<script>

import { ClsUser } from '@/wam/modules/user';
import { ClsWdm } from '@/wam/modules/wdm';
import { ClsRoute } from '@/wam/modules/route';
import store from '@/store';
import { ServiceFunctions } from '@/wam/modules/service';
import {
  default as PageInfo
} from '@/components/widgets/PageInfo';
import {
  default as HtmlEditor
} from '@/wam/components/widgets/HtmlEditor';
import { mapGetters } from 'vuex';
export default {
  name: 'user_discount_record',
  computed: mapGetters({
    StoreDevice: 'StoreDevice',
    StoreLang: 'StoreLang',
    StoreLangList: 'StoreLangList',
    StoreLangTranslation: 'StoreLangTranslation',
    StoreFrontendSettings: 'StoreFrontendSettings',
  }),
  components: {
    PageInfo,
    HtmlEditor,
  },
  props: {},
  data () {
    return {
      d_user: '',
      d_userShopClientID: '',
      d_userDiscountClientID: '',
      d_frontendPackageGroupList: [],
      d_userDiscountWdm: '',
      d_userDiscountData: {
        'status': '0',
        'discount_start_date': '',
        'discount_end_date': '',
        'discount_type': '',
        'discount_name': {},
        'discount_percent': '',
      },
      ClsUser: ClsUser,
      d_selectedUser: '',
    };
  },
  created: function () {
    ClsWdm.getLayerWdm('usr_discount').then(resp_wdm_data => { this.d_userDiscountWdm = resp_wdm_data; });
    this.d_user = JSON.parse(localStorage.getItem('user'));
    if (this.$route.query.user_shop_client_id) {
      this.d_userShopClientID = this.$route.query.user_shop_client_id;
    }

    let auth_eligible = false;
    let user_perm_eligible = false;
    let user_perm_eligibleGeneral = false;
    if (this.$route.meta && this.$route.meta.permission && this.$route.meta.permission.length > 0) {
      auth_eligible = ClsUser.f_checkUserAuth(this.$route.meta.permission, 'without_id');
      if (auth_eligible) {
        user_perm_eligible = ClsUser.f_checkUserAuth([this.d_userShopClientID + '_shop_admin', this.d_userShopClientID + '_shop_bundle_add_edit'],'with_id');
        user_perm_eligibleGeneral = ClsUser.f_checkUserAuth(['admin', 'shop_admin', 'shop_bundle_add_edit']);
      }
    }
    if (this.d_user && this.d_user.username && auth_eligible && (user_perm_eligible || user_perm_eligibleGeneral) ) {
      if (this.d_userShopClientID) {
        if (this.$route.query.user_discount_client_id) {
          this.d_userDiscountClientID = this.$route.query.user_discount_client_id;
          this.f_userDiscountGet();
        } 
        if (this.$route.query.user_client_id) {
          this.d_selectedUser = this.$route.query.user_client_id;
        } 
        if (this.d_selectedUser || this.d_userDiscountClientID) {
        } else {
          alert(this.StoreLangTranslation.data['-'][this.StoreLang]);
          this.f_goToDiscountList();
        }
      } else {
        alert(this.StoreLangTranslation.data['shop_is_not_selected'][this.StoreLang]);
        this.f_goToShopList();
      }
      // if (!this.d_userDiscountClientID) {
      //   this.f_langEligibleParameterProcess();
      // }
      this.f_langEligibleParameterProcess();
    } else {
      this.$router.push({ path: this.StoreLangTranslation.data['page_404_path'][this.StoreLang], query: {} });
    }
  },
  beforeMount () {},
  mounted: function () {
  },
  methods: {
    f_goToShopList: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_shop_list'), query: {} });
    },
    f_goToDiscountList: function () {
      this.$router.push({ path: ClsRoute.f_getRoutePath('user_discount_list'), query: {} });
    },

    f_langEligibleParameterProcess: function () {
      let lang_eligible_variables = ['discount_name'];
      for (let k in lang_eligible_variables) {
        for (let lang_index in this.StoreLangList.data) {
          try {
            if (!this.d_userDiscountData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label]) {
              this.d_userDiscountData[lang_eligible_variables[k]][this.StoreLangList.data[lang_index].label] = '';
            }
          } catch {
            console.log(lang_eligible_variables[k])
          }
        }
      }
    },
    f_userDiscountRecord: function () {
      let query = 'user_client_id=' + this.d_selectedUser;
      let data = {};
      if (this.d_userDiscountClientID) {
        query += '&user_discount_client_id=' + this.d_userDiscountClientID;
      }
      if (this.d_userShopClientID) {
        query += '&user_shop_client_id=' + this.d_userShopClientID;
      }
      data['discount_data'] = this.d_userDiscountData;
      
      if (this.d_userDiscountClientID) {
        ServiceFunctions.user_discount_edit(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      } else {
        ServiceFunctions.user_discount_new(query, data)
          .then(resp => {
            if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            } else {
              alert(resp.data.status_code + ' = ' + resp.data.status_message);
            }
          });
      }
    },
    f_userDiscountGet: function (user_discount_client_id) {
      let query = 'user_discount_client_id=' + this.d_userDiscountClientID;
      query += '&data_type=value_mode';
      query += '&user_shop_client_id=' + this.d_userShopClientID;
      query += '&user_client_id=' + this.d_user.username;
      let data = {};
      ServiceFunctions.user_discount_get(query, data)
        .then(resp => {
          if (resp.data.status_code.substring(resp.data.status_code.length - 3, resp.data.status_code.length) == '000') {
            if (resp.data.data) {
              this.d_userDiscountData = resp.data.data;
              this.f_langEligibleParameterProcess();
            } else {
              alert(this.StoreLangTranslation.data['process_completed'][this.StoreLang]);
            }
          } else {
            alert(resp.data.status_code + ' = ' + resp.data.status_message);
          }
        });
    },
  },
  watch: {}
};

</script>

